/**
 * 作用是 标记默认选中的支付方式
 * 返回默认的支付方式， 以及默认选中时，触发回调函数
 */

import { getPayMethodByCardChannel, getRadioPayMethodByPayMethod } from '../_utils/tool';
import { useEffect, useRef } from 'react';
// 获取默认的支付方式
var getDefaultPayMethod = function getDefaultPayMethod(payChannelList, cardList, selectCard) {
  var _payChannelList$;
  // 支付方式列表中 isDefault 设置为 true 的列表项
  var itemIncludeDefaultSetting = payChannelList === null || payChannelList === void 0 ? void 0 : payChannelList.find(function (item) {
    return item.isDefault === true && item.disabled !== true;
  });

  // 当 已绑卡列表有数据，默认优先有选择 「银行卡支付」。（注： 银行卡支付是指用已绑卡进行支付）
  if (cardList && cardList.length > 0 && selectCard) {
    return getPayMethodByCardChannel(selectCard.payChannel);
  }
  return itemIncludeDefaultSetting ? itemIncludeDefaultSetting.payMethod : payChannelList === null || payChannelList === void 0 ? void 0 : (_payChannelList$ = payChannelList[0]) === null || _payChannelList$ === void 0 ? void 0 : _payChannelList$.payMethod;
};
function useDefaultPayMethod(_ref) {
  var payChannelList = _ref.payChannelList,
    cardList = _ref.cardList,
    selectCard = _ref.selectCard,
    onDefaultPayMethod = _ref.onDefaultPayMethod;
  var defaultPayMethod = getDefaultPayMethod(payChannelList, cardList, selectCard);
  var defaultRadioPayMethod = getRadioPayMethodByPayMethod(cardList, defaultPayMethod);
  var handleDefaultPayMethod = useRef(onDefaultPayMethod);
  useEffect(function () {
    if (defaultPayMethod) {
      handleDefaultPayMethod.current(defaultPayMethod, defaultRadioPayMethod);
    }
  }, [defaultPayMethod, defaultRadioPayMethod]);
  return {
    defaultPayMethod: defaultPayMethod
  };
}
export default useDefaultPayMethod;